module.exports = __webpack_public_path__ + "static/media/5ed4a2b10d826.image.e42211fb.jpg";